module.exports = __webpack_public_path__ + "static/img/4_2.ae35d6a8.jpg";